import type React from 'react';
import { useMemo } from 'react';
import { Table } from 'components';
import { useTablePagination } from '../../../hooks/useTablePagination';
import { getInventoryMetersTableColumns } from './utils/getInventoryMetersTableColumns';
import type { MetersCardTab } from '../enums/MeterCardTab';
import { useCardInventoryMeters } from '../hooks/useCardInventoryMeters';

export const InventoryMetersTable: React.VFC<{ activeMetersTab: MetersCardTab }> = ({ activeMetersTab }) => {
  const { paginationOptions } = useTablePagination(0, 'inventory meters', 1, 20);

  const { data, total, loading } = useCardInventoryMeters(activeMetersTab, paginationOptions);

  const columns = useMemo(() => getInventoryMetersTableColumns(activeMetersTab), [activeMetersTab]);

  return (
    <Table
      columns={columns}
      dataSource={data ?? []}
      loading={loading}
      pagination={{
        ...paginationOptions,
        total: total ?? 0,
      }}
      rowKey="id"
      scroll={{ y: 800, x: true }}
    />
  );
};
